"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getRegExp_1 = __importDefault(require("./getRegExp"));
var validatePatterns_1 = __importDefault(require("./validatePatterns"));
var DoubleCurlyBraces_1 = __importDefault(require("./styles/DoubleCurlyBraces"));
var defaultMissingPathHandler_1 = __importDefault(require("./defaultMissingPathHandler"));
/**
 * Merges the provided options with default options for tag patterns.
 * @param {Partial<ReplaceTagsOptions>} [options] - Optional partial options object.
 * @returns {ReplaceTagsOptions} The merged options object with default values.
 */
var getOptionsWithDefaults = function (_a) {
    var _b = _a === void 0 ? DoubleCurlyBraces_1.default : _a, _c = _b.tagPattern, tagPattern = _c === void 0 ? DoubleCurlyBraces_1.default.tagPattern : _c, _d = _b.tagStartPattern, tagStartPattern = _d === void 0 ? DoubleCurlyBraces_1.default.tagStartPattern : _d, _e = _b.tagEndPattern, tagEndPattern = _e === void 0 ? DoubleCurlyBraces_1.default.tagEndPattern : _e, _f = _b.onMissingPath, onMissingPath = _f === void 0 ? defaultMissingPathHandler_1.default : _f;
    var options = {
        tagPattern: (0, getRegExp_1.default)(tagPattern),
        tagStartPattern: (0, getRegExp_1.default)(tagStartPattern),
        tagEndPattern: (0, getRegExp_1.default)(tagEndPattern),
        onMissingPath: onMissingPath,
    };
    // Validate the provided patterns
    (0, validatePatterns_1.default)(options);
    return options;
};
exports.default = getOptionsWithDefaults;
